import React, { PureComponent } from 'react';

import styles from './styles.less';
import Icon from '~/UI/Icon';
import { TailwindTooltip } from '~/libs/ui/atoms/TailwindTooltip/TailwindTooltip';

interface Props {
	style: any;
}

export default class Header extends PureComponent<Props> {
	static defaultProps = {
		style: null,
	};

	render() {
		const { style } = this.props;

		return (
			<div className={styles.header} style={style}>
				<div className={styles.addOrRemoveCell} />
				<div className={styles.countryCell}>Country</div>
				<div className={styles.brandCell}>Brand name</div>
				<div className={styles.mahCell}>Company</div>
				<div className={styles.dosageCell}>Dosage Form</div>
				<div className={styles.dosageStrengthCell}>Dosage strength</div>
				<div className={styles.packageCell}>Package</div>
				<div className={styles.referencePriceCell}>
					Price
					<TailwindTooltip
						reference={<Icon name='violet-question-mark' />}
						displayClass='inline-block ml-2 h-4 align-top'
						position='left'
					>
						<p className='leading-snug'>
							<strong>Horní cena:</strong> Ex-factory price (zveřejněná, nebo vypočítaná dle SP-CAU-010)
						</p>
						<p className='leading-snug'>
							<strong>Spodní cena (zvýrazněná tučně):</strong> Původní cena zveřejněná ve zdroji (Ex-factory price, nebo
							cena sloužící pro přepočet na Ex-factory price)
						</p>
					</TailwindTooltip>
				</div>
				<div className={styles.pricePerUtddCell}>
					Price per ODTD
					<TailwindTooltip
						reference={<Icon name='violet-question-mark' />}
						displayClass='inline-block ml-2 h-4 align-top'
						position='left'
					>
						<p className='leading-snug'>
							<strong>Price per ODTD:</strong> Cena vzniklá vynásobením ceny (pole Price) obvyklou denní terapeutickou
							dávkou balení (pole ODTDBAL)
						</p>
						<p className='leading-snug'>
							<strong>Horní cena:</strong> Ex-factory price (zveřejněná, nebo vypočítaná dle SP-CAU-010)
						</p>
						<p className='leading-snug'>
							<strong>Spodní cena (zvýrazněná tučně):</strong> Původní cena zveřejněná ve zdroji (Ex-factory price, nebo
							cena sloužící pro přepočet na Ex-factory price)\n
						</p>
					</TailwindTooltip>
				</div>
				<div className={styles.selectionCell}>Use for calc.</div>
			</div>
		);
	}
}
